import createAxiosSecureInstance from './create-axios-sign-instance'
import createAxiosInstance from './create-axios-instance'
import { createQlSignGet, getSignSecure, getSign } from '@/utils'

const apiSecureClient = createAxiosSecureInstance({ timeout: 5000 })
const apiClient = createAxiosInstance({ timeout: 5000 })

//新签名新加密规则json传参
apiClient.postWithSignJson = async function (url, params, isJsonContent, extraHeaders) {
  let headers = getSignSecure(params, isJsonContent)
  let paramData
  if (isJsonContent) {
    paramData = JSON.stringify(params)
  } else {
    paramData = translateParams(params)
  }
  let parameters = {
    url: url,
    method: 'post',
    data: paramData,
    headers: { ...headers, ...extraHeaders }
  }
  try {
    let data = await apiSecureClient.request(parameters)
    return data.data
  } catch (err) {
    return Promise.reject(err)
  }
}

apiClient.getWithSignSecure = async function (url, params, isJsonContent, extraHeaders, noHeaders) {
  let headers = getSignSecure(params, isJsonContent)
  let urlStr = `${url}?${translateParams(params)}`
  let parameters = {
    url: params ? urlStr : url,
    method: 'get',
    headers: noHeaders ? {} : {
      ...headers, ...extraHeaders
    }
  }
  let data = await apiSecureClient.request(parameters)
  return data.data
}

apiClient.getWithQlSign = async function (url, params, extraHeaders) {
  const headers = createQlSignGet(params)
  const urlStr = `${url}?${translateParams(params)}`
  const data = await apiClient.request({
    url: params ? urlStr : url,
    method: 'get',
    headers: { ...headers, ...extraHeaders },
  })
  return data.data
}

apiClient.getWithSign = async function (url, params, isJsonContent, extraHeaders, noHeaders) {
  let headers = getSign(params, isJsonContent)
  let urlStr = `${url}?${translateParams(params)}`
  let parameters = {
    url: params ? urlStr : url,
    method: 'get',
    headers: noHeaders ? {} : {
      ...headers, ...extraHeaders, appcode: 'com.baidao.silver'
    }
  }
  let data = await apiClient.request(parameters)
  return data.data
}

apiClient.postWithSign = async function (url, params, isJsonContent, extraHeaders) {
  let headers = getSign(params, isJsonContent)
  let paramData
  if (isJsonContent) {
    paramData = JSON.stringify(params)
  } else {
    paramData = translateParams(params)
  }
  let parameters = {
    url: url,
    method: 'post',
    data: paramData,
    headers: { ...headers, ...extraHeaders }
  }
  try {
    let data = await apiClient.request(parameters)
    return data.data
  } catch (err) {
    return Promise.reject(err)
  }
}

export default apiClient

const translateParams = (params) => {
  let url = ''
  for (let param in params) {
    url += `${param}=${encodeURIComponent(params[param])}&`
  }
  return url.substring(0, url.length - 1)
}
